import React, { useState } from 'react';
import { useNavigate } from 'react-router';

import CommonPage from '../components/common-page/CommonPage';
import ProjectRequestForm from './components/project-request-form/ProjectRequestForm';
import MessageSentModal from './components/project-request-form/message-sent-modal/MessageSentModal';

function ProjectRequest() {
  const navigate = useNavigate();

  const [isShowMessageSentModal, setIsShowMessageSentModal] = useState(false);

  const handleShowMessageSentModal = () => {
    setIsShowMessageSentModal(true);
  };

  const handleCloseMessageSentModal = () => {
    setIsShowMessageSentModal(false);
    navigate('/projects');
  };

  return (
    <CommonPage>
      <ProjectRequestForm onSentMessage={handleShowMessageSentModal} />

      <MessageSentModal isOpen={isShowMessageSentModal} onClose={handleCloseMessageSentModal} />
    </CommonPage>
  );
}

export default ProjectRequest;
